// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as CountryContext from "../../../../../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as WorkSpaceContext from "../../../../../../../../library/work-space/WorkSpaceContext.bs.js";
import * as ActivityInfoSection from "./AccordionSections/ActivityInfoSection.bs.js";
import * as PunishmentInfoSection from "./AccordionSections/PunishmentInfoSection.bs.js";
import * as CrmServiceabilitySection from "./AccordionSections/CrmServiceabilitySection.bs.js";
import * as MiscellaneousInfoSection from "./AccordionSections/MiscellaneousInfoSection.bs.js";

function DriverRecordAccordion(Props) {
  var msisdn = Props.msisdn;
  var driverInfo = Props.driverInfo;
  var tickets = Props.tickets;
  var orders = Props.orders;
  var suspensionInfo = Props.suspensionInfo;
  var weeklyEarnings = Props.weeklyEarnings;
  var walletInfo = Props.walletInfo;
  var incentives = Props.incentives;
  var terminationInfo = Props.terminationInfo;
  var partnerDocument = Props.partnerDocument;
  var helperServiceabilityInfo = Props.helperServiceabilityInfo;
  var outStationServiceabilityInfo = Props.outStationServiceabilityInfo;
  var premiumPartnerReport = Props.premiumPartnerReport;
  var helperLabourServiceability = Props.helperLabourServiceability;
  var rentalServiceability = Props.rentalServiceability;
  var toggleModal = Props.toggleModal;
  var dispatch = Props.dispatch;
  var workspaceDispatch = WorkSpaceContext.useWorkSpace(undefined);
  var match = CountryContext.useContext(undefined);
  var tmp;
  tmp = match.country.TAG === /* India */1 ? React.createElement(React.Fragment, undefined, React.createElement(PunishmentInfoSection.make, {
              msisdn: msisdn,
              suspensionInfo: suspensionInfo,
              terminationInfo: terminationInfo,
              workspace_dispatch: workspaceDispatch,
              toggleModal: toggleModal
            }), React.createElement(ActivityInfoSection.make, {
              msisdn: msisdn,
              orders: orders,
              tickets: tickets,
              weeklyEarnings: weeklyEarnings,
              walletInfo: walletInfo,
              incentives: incentives,
              workspace_dispatch: workspaceDispatch,
              dispatch: dispatch
            }), React.createElement(MiscellaneousInfoSection.make, {
              driverInfo: driverInfo,
              partnerDocument: partnerDocument,
              premiumPartnerReport: premiumPartnerReport,
              workspace_dispatch: workspaceDispatch,
              msisdn: msisdn,
              dispatch: dispatch
            }), React.createElement(CrmServiceabilitySection.make, {
              msisdn: msisdn,
              driverInfo: driverInfo,
              helperServiceabilityInfo: helperServiceabilityInfo,
              workspace_dispatch: workspaceDispatch,
              outStationServiceabilityInfo: outStationServiceabilityInfo,
              helperLabourServiceability: helperLabourServiceability,
              rentalServiceability: rentalServiceability,
              dispatch: dispatch
            })) : React.createElement(React.Fragment, undefined, React.createElement(PunishmentInfoSection.make, {
              msisdn: msisdn,
              suspensionInfo: suspensionInfo,
              terminationInfo: terminationInfo,
              workspace_dispatch: workspaceDispatch,
              toggleModal: toggleModal
            }), React.createElement(ActivityInfoSection.make, {
              msisdn: msisdn,
              orders: orders,
              tickets: tickets,
              weeklyEarnings: weeklyEarnings,
              walletInfo: walletInfo,
              incentives: incentives,
              workspace_dispatch: workspaceDispatch,
              dispatch: dispatch
            }), React.createElement(CrmServiceabilitySection.make, {
              msisdn: msisdn,
              driverInfo: driverInfo,
              helperServiceabilityInfo: helperServiceabilityInfo,
              workspace_dispatch: workspaceDispatch,
              outStationServiceabilityInfo: outStationServiceabilityInfo,
              helperLabourServiceability: helperLabourServiceability,
              rentalServiceability: rentalServiceability,
              dispatch: dispatch
            }));
  return React.createElement("div", {
              className: "accordion-container-wrapper"
            }, tmp);
}

var make = DriverRecordAccordion;

export {
  make ,
  
}
/* react Not a pure module */
